(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .component("filterSimpleSelect", {
            templateUrl:
                "app/components/filter-simple-select/filter-simple-select.html",
            controller: filterSimpleSelectController,
            bindings: {
                name: "@",
                placeholder: '@',
                options: "<",
                onChange: "&",
                value: "=?",
                fullscreen: '<?',
                model: '=',
                hasSearch: '=?'
            },
        })
        .directive("changeItems", function () {
            return {
                restrict: "A",
                link: function (scope) {
                    scope.$watch("$ctrl.model", function (newValue) {
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ newValue: newValue });
                        }
                    });
                },
            };
        });

    /** @ngInject */
    function filterSimpleSelectController($translate, $window, $scope, systemConstants) {
        var $ctrl = this;

        $ctrl.hasSearch = $ctrl.hasSearch || false;
        $ctrl.searchText = "";
        $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        $ctrl.$onInit = function () {
            $ctrl.selectedOption =
                findOption($ctrl.value);

            if ($ctrl.selectedOption) {
                $ctrl.onChange({ newValue: $ctrl.selectedOption.value });
            }
        };

        $ctrl.getButtonLabel = function () {
            return $translate.instant($ctrl.selectedOption.label);
        };

        $ctrl.selectOption = function (option) {
            $ctrl.model = option;
            if ($ctrl.onChange) {
                $ctrl.onChange({ newValue: option.value });
            }
        };

        $ctrl.isSelected = function(option) {
            return $ctrl.model && $ctrl.model.label === option.label;
        };

        $ctrl.getPlaceholderText = function () {
            if (!$ctrl.model) {
                return $translate.instant($ctrl.placeholder);
            } else {
                return $translate.instant($ctrl.placeholder) + ' | ';
            }
        };

        $ctrl.getSelectedText = function () {
            return $translate.instant($ctrl.model.label);
        };

        $ctrl.clearSelection = function ($event) {
            $event.stopPropagation();
            $ctrl.model = null;

            if ($ctrl.onChange) {
                $ctrl.onChange({ newValue: null });
            }

            if (typeof $ctrl.actionOnClose === 'function') {
                $timeout(function () {
                    $ctrl.actionOnClose();
                }, 0);
            }
        };

        $ctrl.notifyChange = function () {
            if ($ctrl.onChange) {
                $ctrl.onChange({ newValue: $ctrl.model ? $ctrl.model.value : null });
            }
        };

        function findOption(value) {
            if (!$ctrl.options) return null;
            for (var i = 0; i < $ctrl.options.length; i++) {
                if ($ctrl.options && $ctrl.options[i] && $ctrl.options[i].value === value) {
                    return $ctrl.options[i];
                }
            }
            return null;
        }
    }
})();
